import React from 'react';

import { css } from '@emotion/css';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { useStyles } from '@/hooks/useStyles.ts';
import { Theme } from '@/theme/CreateTheme.ts';
import { CardContent } from '@/uiKit/atoms/card/CardContent.tsx';
import { ControlledTextField } from '@/uiKit/molecules/ControlledTextField.tsx';

export const PatientInfoFormContent: React.FC = ({}) => {
  const styles = useStyles(makeStyles);
  const { t } = useTranslation();

  return (
    <CardContent>
      <Typography variant="subtitle" component="h6">
        {t('pages.patientMonitoring.patient.title')}
      </Typography>
      <div className={styles.formRow}>
        <div className={styles.aside}>
          <ControlledTextField
            id="patient-info-given-name-input"
            required
            name="givenName"
            label={t('profile.firstname')}
            variant="standard"
          />
          <ControlledTextField
            id="patient-info-family-name-input"
            required
            name="familyName"
            label={t('profile.lastname')}
            variant="standard"
          />
        </div>
      </div>
      <div className={styles.formRow}>
        <ControlledTextField
          id="patient-info-email-input"
          required
          name="email"
          label={t('form.email.label')}
          variant="standard"
        />
      </div>
      <div className={styles.formRow}>
        <ControlledTextField
          id="patient-info-phone-input"
          required
          name="phone"
          label={t('form.phone.label')}
          variant="standard"
        />
      </div>
    </CardContent>
  );
};

const makeStyles = (theme: Theme) => ({
  formRow: css`
    display: flex;
    padding-bottom: ${theme.spacing(10)};
    width: 100%;
  `,
  footer: css`
    display: flex;
    justify-content: right;
    padding-top: ${theme.spacing(10)};
    padding-bottom: ${theme.spacing(10)};
    gap: ${theme.spacing(20)};
    width: 100%;
  `,
  aside: css`
    justify-content: space-between;
    display: flex;
    gap: ${theme.spacing(20)};
    width: 100%;
  `,
});
